import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  ElementRef
} from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { DataService } from '../../core/data/data.service';
import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import {
  MutateLocationGQL,
  LocationInput,
  ProductName,
  ContactInput,
  LocationType,
  MutationType
} from '../../core/graphql-client/graphql';
import { Environment } from '../../core/environment';
import { Overlay } from '@angular/cdk/overlay';
import { ConfirmationDialogComponent } from '../../core/dialogs/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'finders-location-edit',
  templateUrl: './location-edit.component.html',
  styleUrls: ['./location-edit.component.scss']
})
export class LocationEditComponent implements OnInit {
  constructor(
    public env: Environment,
    public fb: FormBuilder,
    private mutateLocationGQL: MutateLocationGQL,
    private data: DataService,
    private router: Router,
    private dialog: MatDialog,
    private overlay: Overlay
  ) {}
  locationID: String;
  captcha = false;
  loc;

  @ViewChild('successDialog', { static: false }) successDialog: TemplateRef<
    any
  >;
  @ViewChild('removeDialog', { static: false }) removeDialog: TemplateRef<any>;
  @ViewChild('confirmRemoveDialog', { static: false })
  confirmRemoveDialog: TemplateRef<any>;
  @ViewChild('topOfForm', { static: false }) topOfForm: ElementRef<any>;

  public location_type: LocationType;
  public form: FormGroup;
  public landingImage: string;

  public validateForm() {
    if (this.form.valid) {
      this.openConfirmationDialog();
    } else {
      this.topOfForm.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }

  getInputsFromForm(_form) {
	console.log('getting input form..');
    const locationInput: LocationInput = {
      id: parseInt(this.loc.id, 10),
      customerID: parseInt(this.loc.customerID, 10),
      name: _form.location_name,
      address1: _form.address_one,
      address2: _form.address_two,
      city: _form.city,
      state: _form.state,
      zipCode: _form.zip_code,
      locationPhone: _form.location_phone,
      locationFax: 'n/a'
    };

    const contactInput: ContactInput = {
      firstName: _form.first_name,
      lastName: _form.last_name,
      phone: _form.phone,
      fax: _form.fax,
      email: _form.email_address
    };

    const locationType = <LocationType>this.location_type;

    const productName = this.env.product;

    return {
      locationInput,
      contactInput,
      locationType,
      productName
    };
  }

  openConfirmationDialog() {
    const config = new MatDialogConfig();
    config.data = this.form;
    config.scrollStrategy = this.overlay.scrollStrategies.noop();
    this.dialog
      .open(ConfirmationDialogComponent, config)
      .afterClosed()
      .subscribe(result => {
        if (result !== 'cancel') {
          this.updateLocationFromForm(this.form.value);
        }
      });
  }

  updateLocationFromForm(_form) {
    const {
      locationInput,
      contactInput,
      locationType,
      productName
    } = this.getInputsFromForm(_form);

    return this.updateLocation(
      locationInput,
      contactInput,
      locationType,
      productName
    );
  }

  removeLocationFromForm(_form) {
	  console.log('Remove Request');
    const {
      locationInput,
      contactInput,
      locationType,
      productName
    } = this.getInputsFromForm(_form);

    return this.removeLocation(
      locationInput,
      contactInput,
      locationType,
      productName
    );
  }

  public updateLocation(
    _locationInput: LocationInput,
    _contactInput: ContactInput,
    _locationType: LocationType,
    _productName: ProductName
  ) {
    this.mutateLocationGQL
      .mutate({
        location: _locationInput,
        contact: _contactInput,
        locationType: _locationType,
        productName: _productName,
        mutationType: MutationType.Update
      })
      .subscribe(({ data }) => {
        if (data['mutateLocation'].statusCode === '200') {
          this.openSuccessDialog();
        }
      });
  }

  public removeLocation(
    _locationInput: LocationInput,
    _contactInput: ContactInput,
    _locationType: LocationType,
    _productName: ProductName
  ) {
	
	if(_locationInput.locationPhone==null){
		
        _locationInput.locationPhone="";		
	}
	if(_contactInput.firstName==null){
		_contactInput.firstName="";
	}
	if(_contactInput.lastName==null){
		_contactInput.lastName="";
	}
	if(_contactInput.phone==null){
		_contactInput.phone="";
	}
	if(_contactInput.fax==null){
		_contactInput.fax="";
	}
	if(_contactInput.email==null){
		_contactInput.email="";
	}

	
	  
    this.mutateLocationGQL
      .mutate({
        location: _locationInput,
        contact: _contactInput,
        locationType: _locationType,
        productName: _productName,
        mutationType: MutationType.Remove
      })
      .pipe(first())
      .subscribe(({ data }) => {
        if (data['mutateLocation'].statusCode === '200') {
          this.openRemoveDialog();
        }
      });
  }

  openSuccessDialog() {
    this.dialog
      .open(this.successDialog)
      .afterClosed()
      .subscribe(() => {
        this.router.navigate(['']);
      });
  }

  openConfirmRemoveDialog() {
    this.dialog.closeAll();
    this.dialog
      .open(this.confirmRemoveDialog)
      .afterClosed()
      .subscribe(result => {
        if (result !== 'cancel') {
          this.removeLocationFromForm(this.form.value);
        }
      });
  }

  openRemoveDialog() {
    this.dialog.closeAll();
    this.dialog
      .open(this.removeDialog)
      .afterClosed()
      .subscribe(() => {
        this.router.navigate(['']);
      });
  }

  ngOnInit() {
    const randomOneThroughFive = Math.floor(Math.random() * 5) + 1;

    this.landingImage = 'join__header landing-image-' + randomOneThroughFive;

    this.data.currentMessage.subscribe(message => {
      if (
        message.location === undefined ||
        message.locationType === undefined
      ) {
        this.router.navigate(['']);
      } else {
        this.loc = message.location;

        this.form = this.fb.group({
          location_name: [
            message.location.name,
            [Validators.required, Validators.minLength(1)]
          ],
          address_one: [
            message.location.address1,
            [Validators.required, Validators.minLength(1)]
          ],
          address_two: [message.location.address2, [Validators.minLength(1)]],
          city: [
            message.location.city,
            [Validators.required, Validators.minLength(1)]
          ],
          state: [
            message.location.state,
            [Validators.required, Validators.minLength(1)]
          ],
          zip_code: [
            message.location.zipCode,
            [Validators.required, Validators.minLength(5)]
          ],
          location_phone: [
            message.location.phone,
            [Validators.required, Validators.minLength(1)]
          ],
          location_fax: [
            message.location.locationFax,
            [Validators.minLength(1)]
          ],
          first_name: [message.location.firstName, [Validators.required, Validators.minLength(1)]],
          last_name: [message.location.lastName, [Validators.required, Validators.minLength(1)]],
          phone: [
            message.location.cPhone,
            [Validators.required, Validators.minLength(1)]
          ],
          fax: [message.location.cFax, [Validators.minLength(1)]],
          email_address: [message.location.email, [Validators.required, Validators.email]]
        });

        switch (message.locationType) {
          case LocationType.Treatment: {
            this.selectTreatment();
            break;
          }

          case LocationType.Pharmacy: {
            this.selectPharmacy();
            break;
          }
        }
      }
    });
  }

  cancelForm() {
    this.selectTreatment();

    this.form = this.fb.group({
      location_name: ['', [Validators.required, Validators.minLength(1)]],
      address_one: ['', [Validators.required, Validators.minLength(1)]],
      address_two: ['', [Validators.minLength(1)]],
      city: ['', [Validators.required, Validators.minLength(1)]],
      state: ['', [Validators.required, Validators.minLength(1)]],
      zip_code: ['', [Validators.required, Validators.minLength(5)]],
      location_phone: ['', [Validators.required, Validators.minLength(1)]],
      location_fax: ['', [Validators.minLength(1)]],
      first_name: ['', [Validators.required, Validators.minLength(1)]],
      last_name: ['', [Validators.required, Validators.minLength(1)]],
      phone: ['', [Validators.required, Validators.minLength(1)]],
      fax: ['', [Validators.minLength(1)]],
      email_address: ['', [Validators.required, Validators.email]]
    });

    this.router.navigate(['']);
  }

  selectPharmacy() {
    this.location_type = LocationType.Pharmacy;
  }

  selectTreatment() {
    this.location_type = LocationType.Treatment;
  }
}
